/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S2_Li2Inputs */

const tr_servis_s2_li2 = /** @type {(inputs: Servis_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faturalandırma aylık veya yıllık olabilir; yıllık ödemede indirim uygulanır.`)
};

const en_servis_s2_li2 = /** @type {(inputs: Servis_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing may be monthly or annual; a discount applies to annual payment.`)
};

const de_servis_s2_li2 = /** @type {(inputs: Servis_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Rechnungsstellung kann monatlich oder jährlich erfolgen; bei jährlicher Zahlung wird ein Rabatt gewährt.`)
};

const ru_servis_s2_li2 = /** @type {(inputs: Servis_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выставление счетов может быть ежемесячным или ежегодным; при годовой оплате предоставляется скидка.`)
};

/**
* | output |
* | --- |
* | "Billing may be monthly or annual; a discount applies to annual payment." |
*
* @param {Servis_S2_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s2_li2 = /** @type {((inputs?: Servis_S2_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S2_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s2_li2(inputs)
	if (locale === "de") return de_servis_s2_li2(inputs)
	if (locale === "ru") return ru_servis_s2_li2(inputs)
	return tr_servis_s2_li2(inputs)
});